import { useEffect, useState } from "react";

/**
 * Hold the end-of-game summary overlay for a short beat after the terminal
 * frame, so the FINAL move's collect animation (the last trick's hold+sweep,
 * a challenge reveal, the closing capture) reads on the felt before the
 * overlay covers it. Instant under the test seam (`__BING_INSTANT_LOAD__`),
 * same as the timed boot bar.
 */
export const END_REVEAL_DELAY_MS = 1400;

export function useEndReveal(active: boolean, delayMs: number = END_REVEAL_DELAY_MS): boolean {
  const instant =
    typeof window !== "undefined" &&
    (window as { __BING_INSTANT_LOAD__?: boolean }).__BING_INSTANT_LOAD__ === true;
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!active) {
      setShown(false);
      return undefined;
    }
    if (instant) {
      setShown(true);
      return undefined;
    }
    const t = setTimeout(() => setShown(true), delayMs);
    return () => clearTimeout(t);
  }, [active, delayMs, instant]);
  return active && (shown || instant);
}
